//* 취약 비밀번호 계정 표식 — 사이드바 계정 링크 옆에 붙는다
import { FC } from 'react';

import { useAuth } from '@shared/state/hooks/useAuth';

/**
 * 서버가 `security.isWeakPassword === true` 로 판정한 계정만. 고객은 판정 자체가 없어(undefined) 안 뜬다.
 * 배지를 단 링크는 계정정보로 가고, 거기서 비밀번호를 바꾸면 다음 프로필 갱신에서 사라진다.
 * 백엔드 스펙: smartbugo-api/docs/account-security.md
 */
export const WeakPasswordBadge: FC<{ className?: string }> = ({ className = '' }) => {
  const { userProfile } = useAuth();
  if (userProfile?.security?.isWeakPassword !== true) return null;
  return (
    <span
      className={`inline-flex shrink-0 items-center rounded-full bg-red-500 px-1.5 py-0.5 text-[10px] font-bold leading-none text-white ${className}`}
      title="비밀번호가 취약합니다. 계정정보에서 변경해 주세요."
    >
      비밀번호 취약
    </span>
  );
};
